module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showTabbar) ? _c('div', {
    staticStyle: {
      "position": "fixed",
      "left": "0",
      "bottom": "0",
      "right": "0",
      "width": "100%",
      "height": "55px"
    }
  }, [(this.$store.state.hideTabbar) ? _c('tabbar', {
    model: {
      value: (_vm.returnShowTabBarIndex),
      callback: function($$v) {
        _vm.returnShowTabBarIndex = $$v
      },
      expression: "returnShowTabBarIndex"
    }
  }, [_c('tabbar-item', {
    attrs: {
      "link": "/home"
    },
    on: {
      "on-item-click": function($event) {
        return _vm.menuClick(0)
      }
    }
  }, [_c('i', {
    staticClass: "menu_box",
    class: [_vm.curTab == 0 ? 'home_2' : 'home_1'],
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("首页")])]), _vm._v(" "), _c('tabbar-item', {
    attrs: {
      "link": "/productList"
    },
    on: {
      "on-item-click": function($event) {
        return _vm.menuClick(1)
      }
    }
  }, [_c('i', {
    staticClass: "menu_box",
    class: [_vm.curTab == 1 ? 'repayment_2' : 'repayment_1'],
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("我要融资")])]), _vm._v(" "), _c('tabbar-item', {
    attrs: {
      "link": "/me"
    },
    on: {
      "on-item-click": function($event) {
        return _vm.menuClick(2)
      }
    }
  }, [_c('i', {
    staticClass: "menu_box",
    class: [_vm.curTab == 2 ? 'me_2' : 'me_1'],
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("我的")])]), _vm._v(" "), _c('tabbar-item', {
    attrs: {
      "link": "/more"
    },
    on: {
      "on-item-click": function($event) {
        return _vm.menuClick(3)
      }
    }
  }, [_c('i', {
    staticClass: "menu_box",
    class: [_vm.curTab == 3 ? 'more_2' : 'more_1'],
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("更多")])])], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c05527b"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bottom.vue
// module id = 544
// module chunks = 90